import { api } from '../emptyApi';
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        getApiHeader: build.query<GetApiHeaderApiResponse, GetApiHeaderApiArg>({
            query: () => ({ url: `/api/header` }),
        }),
        getApiHeaderSearchsuggestions: build.query<
            GetApiHeaderSearchsuggestionsApiResponse,
            GetApiHeaderSearchsuggestionsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/header/searchsuggestions`,
                params: {
                    searchTerm: queryArg.searchTerm,
                },
            }),
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as generatedApi };
export type GetApiHeaderApiResponse = /** status 200 Success */ HeaderModel;
export type GetApiHeaderApiArg = void;
export type GetApiHeaderSearchsuggestionsApiResponse =
    /** status 200 Success */ SearchAutoCompleteSuggestionModel[];
export type GetApiHeaderSearchsuggestionsApiArg = {
    searchTerm?: string;
};
export type LogoModel = {
    name?: string;
    url?: string;
    isExternal?: boolean;
    isCurrent?: boolean;
    shouldOpenInNewWindow?: boolean;
    invisibleTextTranslation?: string;
    imageSrc?: string;
    imageAlt?: string;
    storeName?: string;
    homepageTitle?: string;
    clientCode?: string;
};
export type AppModel = {
    name?: string;
    url?: string;
    isExternal?: boolean;
    isCurrent?: boolean;
    shouldOpenInNewWindow?: boolean;
    invisibleTextTranslation?: string;
};
export type LinkModel = {
    name?: string;
    url?: string;
    isExternal?: boolean;
    isCurrent?: boolean;
    shouldOpenInNewWindow?: boolean;
    invisibleTextTranslation?: string;
};
export type AccountMenuItemModel = {
    name?: string;
    url?: string;
    isExternal?: boolean;
    isCurrent?: boolean;
    shouldOpenInNewWindow?: boolean;
    invisibleTextTranslation?: string;
};
export type AccountMenuModel = {
    firstName?: string;
    lastName?: string;
    menuItems?: AccountMenuItemModel[];
    logoutUrl?: string;
    loginUrl?: string;
    createAccountUrl?: string;
};
export type ShoppingCartModel = {
    name?: string;
    url?: string;
    isExternal?: boolean;
    isCurrent?: boolean;
    shouldOpenInNewWindow?: boolean;
    invisibleTextTranslation?: string;
    itemCount?: number;
};
export type LanguageModel = {
    name?: string;
    url?: string;
    isExternal?: boolean;
    isCurrent?: boolean;
    shouldOpenInNewWindow?: boolean;
    invisibleTextTranslation?: string;
    code?: string;
};
export type CurrencyModel = {
    name?: string;
    url?: string;
    isExternal?: boolean;
    isCurrent?: boolean;
    shouldOpenInNewWindow?: boolean;
    invisibleTextTranslation?: string;
};
export type HeaderModel = {
    logo?: LogoModel;
    apps?: AppModel[];
    navigationLinks?: LinkModel[];
    accountMenu?: AccountMenuModel;
    shoppingCart?: ShoppingCartModel;
    languages?: LanguageModel[];
    currencies?: CurrencyModel[];
    searchUrl?: string;
};
export type SearchAutoCompleteSuggestionModel = {
    label?: string;
    url?: string;
};
export const {
    useGetApiHeaderQuery,
    useLazyGetApiHeaderQuery,
    useGetApiHeaderSearchsuggestionsQuery,
    useLazyGetApiHeaderSearchsuggestionsQuery,
} = injectedRtkApi;
